module.exports = __webpack_public_path__ + "static/media/bg_lights.5bbcc142.png";